import React, { useContext, useEffect } from 'react';
import { VendorContext } from './VendorPublicPage';
import InboxPushSubscription from './InboxPushSubscription';
import '../styles/Inbox.css';
import MarketingConsentToggle from './MarketingConsentToggle';

function Inbox({ onClose }) {
  const { notifications, handleMarkAsRead, fetchNotifications, vendorId, vendorName, iosPwaHandler } = useContext(VendorContext);

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications, vendorId]);

  // Create a Set of unique notification bodies
  const uniqueNotifications = Array.from(new Set(notifications.map(n => n.body)))
    .map(body => notifications.find(n => n.body === body));

  return (
    <div className="inbox-container">
      <div className="inbox-header">
        <h2 className="inbox-title">Inbox</h2>
        <button onClick={onClose} className="btn-close-inbox">
          Close
        </button>
      </div>

      <div className="inbox-subscription">
        <InboxPushSubscription iosPwaHandler={iosPwaHandler} />
       <MarketingConsentToggle vendorName={vendorName} />
      </div>

      <div className="inbox-body">
        {uniqueNotifications.length === 0 ? (
          <div className="empty-state">
            <p>No notifications yet</p>
          </div>
        ) : (
          <ul className="notification-list">
            {uniqueNotifications.map(notification => (
              <li 
                key={notification.id} 
                className={`notification-item ${notification.is_read ? 'is-read' : 'is-unread'}`}
              >
                <div className="notification-main">
                  <div className="notification-text-area">
                    <h3 className="notification-title">{notification.title}</h3>
                    <p className="notification-message">{notification.body}</p>
                    <span className="notification-timestamp">
                      {new Date(notification.created_at).toLocaleString()}
                    </span>
                  </div>
                  
                  {!notification.is_read && (
                    <div className="notification-actions">
                      <button 
                        onClick={() => handleMarkAsRead(notification.id)} 
                        className="btn-mark-read"
                      >
                        Mark as Read
                      </button>
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default Inbox;